import { useState } from 'react';
import Slider from 'react-slick';
import { ImageLazy } from 'components/ImageLazy';
import { LazyContainer } from 'components/ImageLazy/styled';
import { slidesConfig } from 'utils/constant';
import { Images } from 'assets/images';
import {
  ContentContainer,
  StyledClientsFeedbackSection,
  CarouselCont,
  CarouselArrow,
  SliderItemTitleBlock,
  SliderSectionTitle,
  SliderSectionSubTitle,
  SliderItemTitle,
  SliderItemInfo,
  SliderItemContainer,
  SliderItemImage,
} from './styled';

const CarouselNextArrow = (props) => {
  const { onClick } = props;
  return (
    <CarouselArrow right onClick={onClick}>
      <img src={Images.whiteArrowRight} alt="Icon" />
    </CarouselArrow>
  );
};

const CarouselPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <CarouselArrow onClick={onClick}>
      <img src={Images.whiteArrowLeft} alt="Icon" />
    </CarouselArrow>
  );
};

export const ClientsFeedbackSection = () => {
  const [slideItemInfo, setSlideItemInfo] = useState(slidesConfig[0].info);

  const settings = {
    className: 'carousel',
    centerMode: true,
    centerPadding: '30px',
    slidesToShow: 5,
    speed: 400,
    touchMove: false,
    nextArrow: <CarouselNextArrow />,
    prevArrow: <CarouselPrevArrow />,
    beforeChange: (oldIdx, newIdx) => {
      setSlideItemInfo(slidesConfig[newIdx].info);
    },
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          centerPadding: '0',
        },
      },
      {
        breakpoint: 769,
        settings: {
          centerPadding: '0',
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 426,
        settings: {
          centerPadding: '0',
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <StyledClientsFeedbackSection name="clients-feedback">
      <LazyContainer>
        <ImageLazy
          src={Images.bgHomeSlider}
          width="100%"
          height="100%"
          hash="LqBE%hJDxWWBX=xaaxa}x^awWYof"
        />
      </LazyContainer>
      <SliderSectionTitle> What Our Clients say</SliderSectionTitle>

      <ContentContainer name="clients-feedback">
        <SliderSectionSubTitle>{slideItemInfo.comment}</SliderSectionSubTitle>
        <CarouselCont>
          <SliderItemTitleBlock>
            <SliderItemTitle>{slideItemInfo.name}</SliderItemTitle>
            <SliderItemInfo>{slideItemInfo.country}</SliderItemInfo>
          </SliderItemTitleBlock>

          <Slider {...settings}>
            {slidesConfig.map((item) => (
              <SliderItemContainer key={item.id}>
                <SliderItemImage className="slider-active-item">
                  <ImageLazy height="100%" width="100%" alt="Slide" src={item.img} />
                </SliderItemImage>
              </SliderItemContainer>
            ))}
          </Slider>
        </CarouselCont>
      </ContentContainer>
    </StyledClientsFeedbackSection>
  );
};
